var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2631_16776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48Z",
    fill: "#C8EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 20.746V11.2002L16.9209 24.2172L24.4997 20.746Z",
    fill: "#6CB3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 20.746V11.2002L32.079 24.2172L24.5002 20.746Z",
    fill: "#4A6C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 31.1599L16.9209 25.9531L24.4997 22.2939L32.0785 25.9531L24.4997 31.1599Z",
    fill: "#133444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 28.9902V20.7461L16.9209 24.2173L24.4997 28.9902Z",
    fill: "#3D5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 28.9902V20.7461L32.079 24.2173L24.5002 28.9902Z",
    fill: "#1A425A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28.1226C16.5 27.0812 16.7807 26.0978 16.921 25.9531L24.4998 31.1598C24.4998 32.0277 24.2613 32.9461 23.6998 33.8139C22.0157 36.4173 19.0262 35.065 17.7631 32.8954C16.5 30.726 16.5 29.4242 16.5 28.1226Z",
    fill: "#6CB3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4998 28.1226C32.4998 27.0812 32.2191 26.0978 32.0788 25.9531L24.5 31.1598C24.5 32.0277 24.7386 32.9462 25.2999 33.8139C26.9842 36.4173 29.9735 35.065 31.2367 32.8954C32.4998 30.726 32.4998 29.4242 32.4998 28.1226Z",
    fill: "#4A6C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1316 35.0643C23.6578 35.0643 24.4999 32.4609 24.4999 31.1592C24.4999 32.4609 25.342 35.0643 27.8683 35.0643C29.5525 35.0643 30.8156 33.3287 31.2366 32.8948C29.9735 35.0643 27.5314 36.7999 24.4999 36.7999C21.4684 36.7999 19.0263 35.0643 17.7632 32.8948C18.1842 33.3287 19.4473 35.0643 21.1316 35.0643Z",
    fill: "#509CBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2631_16776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortis);
export default __webpack_public_path__ + "static/media/portis.23dfa5100cd81573fd93aec0de197ee7.svg";
export { ForwardRef as ReactComponent };